var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import useGenerateTableColumns from "@frameworks/NCD/Hook/TabContent/useGenerateTableColumns";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import { addCommasWithConditionalDecimalWithNA } from "@domains/utils/numberMethods";
var generateProductBouquetTableColumns = function (_a) {
    var id = _a.id, checked = _a.checked, handleCheck = _a.handleCheck, handleSelectAll = _a.handleSelectAll, handleTransactionClick = _a.handleTransactionClick, handleBookmark = _a.handleBookmark, onClickShare = _a.onClickShare, _b = _a.isBookmarkFunctionality, isBookmarkFunctionality = _b === void 0 ? true : _b, _c = _a.isSaveProduct, isSaveProduct = _c === void 0 ? false : _c, subCategoryId = _a.subCategoryId, allTabPage = _a.allTabPage;
    var _d = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), watchListRequestPayload = _d.watchListRequestPayload, subCategoryIdState = _d.subCategoryId;
    var renderCell = function (value) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt-grey-shade1 Roboto_16_400" }, value || "--")); };
    var renderSchemeName = function () {
        switch (subCategoryId || subCategoryIdState) {
            case ESubProductIds.NCD:
                return "NCD Name";
            case ESubProductIds.StructuredProducts:
                return "Product Name";
            case ESubProductIds.Bonds:
                return "Bond Name";
            case ESubProductIds.UnlistedShares:
                return "Company";
            default:
                return "";
        }
    };
    var sharedColumnRightProps = {
        type: "string",
        applySorting: true,
        arrowClassName: "justify-content-end",
        columnClassName: "text-end DMSansMedium_12_500",
    };
    var sharedColumnLeftProps = {
        type: "string",
        applySorting: true,
        arrowClassName: "justify-content-start",
        columnClassName: "text-start DMSansMedium_12_500",
    };
    var columnDefs = {
        rating: {
            columnName: React.createElement("div", { className: "d-flex align-items-center gap-1" }, "Rating"),
            key: "rating",
            applySorting: false,
            arrows: false,
            type: "string",
            tdCustomFunction: function (value) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt-grey-shade1 DMSanN_16_400" }, value || "--")); },
            columnClassName: "text-start DMSansMedium_12_500",
            arrowClassName: "justify-content-start",
        },
        interest_frequency: __assign(__assign({ columnName: ESubProductIds.Bonds === (subCategoryId || subCategoryIdState) ? (React.createElement("div", null,
                "Payout ",
                React.createElement("br", null),
                " Frequency")) : (React.createElement("div", null, "Payout Frequency")), key: "interest_frequency" }, sharedColumnLeftProps), { sortKey: "interest_frequency", arrows: true, tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt-grey-shade1 DMSanN_16_400" }, keys || "--")); } }),
        price_range: __assign(__assign({ columnName: ESubProductIds.Bonds === (subCategoryId || subCategoryIdState) ? (React.createElement("div", null,
                "Price per",
                React.createElement("br", null),
                " Qty (\u20B9)")) : (React.createElement("div", null, "Price per Qty (\u20B9)")), keysForCustomFunction: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                ? ["price_range_buy"]
                : ["price_range"] }, sharedColumnRightProps), { sortKey: "price_range", arrows: true, tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray Roboto_16_400" }, keys[0] || "--")); } }),
        avl_qty: __assign(__assign({ columnName: ESubProductIds.Bonds === (subCategoryId || subCategoryIdState) ? (React.createElement("div", null,
                "Available ",
                React.createElement("br", null),
                " Qty")) : (React.createElement("div", null, "Available Qty")), keysForCustomFunction: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                ? ["virtual_buy_qty"]
                : ["avl_qty"] }, sharedColumnRightProps), { sortKey: "avl_qty", arrows: true, tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray Roboto_16_400" }, addCommasWithConditionalDecimalWithNA(Number(keys[0])) || "--")); } }),
        coupon_rate: __assign(__assign({ columnName: (React.createElement("div", null,
                "Coupon",
                React.createElement("br", null),
                " Rate (%)")), key: "coupon_rate" }, sharedColumnRightProps), { sortKey: "coupon_rate", arrows: true, tdCustomFunction: function (value) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray Roboto_16_400" }, value || "--")); } }),
        coupon_rate_simple: __assign(__assign({ columnName: ESubProductIds.Bonds === (subCategoryId || subCategoryIdState) ? (React.createElement("div", null,
                "Coupon ",
                React.createElement("br", null),
                " Rate (%)")) : (React.createElement("div", null, "Coupon Rate (%)")), key: "coupon_rate" }, sharedColumnRightProps), { sortKey: "coupon_rate", arrows: true, tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray Roboto_16_400" }, keys || "--")); } }),
        maturity_date: {
            columnName: (React.createElement("div", null,
                "Maturity Date",
                React.createElement("br", null),
                "Remaining Period")),
            applySorting: true,
            sortKey: "maturitydate",
            arrows: true,
            arrowClassName: "justify-content-end",
            columnClassName: "text-end",
            keysForCustomFunction: ["maturity_date", "remain_period"],
            tdCustomFunction: function (keys) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                React.createElement("p", { className: "txt_medium-gray RobotoM_16_500" }, moment(keys === null || keys === void 0 ? void 0 : keys[0]).format("DD MMM YY") || "--"),
                React.createElement("p", { className: "DMSanN_14_300 txt-independence" }, (keys === null || keys === void 0 ? void 0 : keys[1]) || "--"))); },
        },
    };
    var getCustomColumns = function () {
        switch (subCategoryId || subCategoryIdState) {
            case ESubProductIds.NCD:
                return [
                    columnDefs.rating,
                    columnDefs.coupon_rate_simple,
                    columnDefs.price_range,
                    columnDefs.avl_qty,
                    columnDefs.interest_frequency,
                ];
            case ESubProductIds.Bonds:
                return [
                    columnDefs.rating,
                    columnDefs.maturity_date,
                    columnDefs.coupon_rate_simple,
                    columnDefs.price_range,
                    columnDefs.avl_qty,
                    columnDefs.interest_frequency,
                ];
            case ESubProductIds.StructuredProducts:
                return [
                    columnDefs.rating,
                    columnDefs.maturity_date,
                    columnDefs.price_range,
                    columnDefs.avl_qty,
                ];
            case ESubProductIds.UnlistedShares:
                return [columnDefs.price_range, columnDefs.avl_qty];
            default:
                return [];
        }
    };
    return useGenerateTableColumns({
        id: id,
        checked: checked,
        handleCheck: handleCheck,
        handleSelectAll: handleSelectAll,
        handleTransactionClick: handleTransactionClick,
        handleBookmark: handleBookmark,
        customColumns: getCustomColumns(),
        customSchemeColumn: {
            columnName: renderSchemeName(),
        },
        onClickShare: onClickShare,
        isBookmarkFunctionality: isBookmarkFunctionality,
        isSaveProduct: isSaveProduct,
        allTabPage: allTabPage,
    });
};
export default generateProductBouquetTableColumns;
